<div class="flex flex-col min-h-screen w-full relative" *ngIf="!loading">

  <!-- Header -->
   <!-- Header -->
  <header class="fixed relative top-0 z-50 w-full bg-white border-b border-gray-200 h-20 flex items-center px-4 shadow-sm">

      <div class="absolute left-1/2 transform -translate-x-1/2">
        <img src="images/logo/logo-text-manusa.png" alt="Logo" class="h-12" />
      </div>

      <button (click)="close()" class="absolute right-4 text-center text-gray-600 hover:text-primary">
        <mat-icon svgIcon="mat_outline:close" class="w-6 h-6"></mat-icon>
      </button>
  </header>

  <div class="flex-1 flex flex-col overflow-auto w-full">

    <!-- Casos exito -->
    <div class="flex flex-1 items-center bg-card justify-center p-6" *ngIf="!error">
      <app-registration-message
        class="max-w-xl"
        [icon]="'mat_outline:check_circle'"
        [iconColor]="'text-green-600'"
        [title]="isAccepted ? ('User accepted' | transloco) : ('Request rejected successfully' | transloco)"
        [message]="isAccepted
          ? ('An email will be sent notifying the user that they have been accepted into the company.' | transloco)
          : ('The request was rejected. The user will be notified.' | transloco)"
      />
    </div>

    <!-- Error general -->
    <div *ngIf="error" class="flex flex-1 items-center bg-card justify-center p-6">
      <app-registration-message
        class="mb-8 justify-center items-center"
        [icon]="'mat_outline:error_outline'"
        [iconColor]="'text-red-600'"
        [title]="'Something went wrong' | transloco"
        [message]="'We couldn’t process the confirmation. Please try again or contact support.' | transloco"
      />
    </div>

  <div class="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 px-4 py-6 z-50">
    <div class="flex justify-center">
      <button
        class="w-64"
        mat-flat-button
        color="primary"
        type="button"
        (click)="onSubmit()"
      >
        {{ 'Finish' | transloco }}
      </button>
    </div>
  </div>
</div>
